
<template>
    <Card container-class="card shadow-sm" :title="$t('events.nps.detail')">
        <template #cardToolbar>
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm" btn-text="back" @click="backList"></Button>
        </template>
        <template #cardBody>
            <div class="row g-7">
                <div class="col-lg-3 col-xl-3 col-12 mt-30">
                    <div class="card card-flush shadow-sm">
                        <div class="card-body">
                            <ul class="nav nav-tabs nav-pills nav-fill border-0 flex-column mb-3 mb-md-0 fs-6">
                            <li v-for="(item, index) in menuItems" :key="index" class="nav-item me-0 mt-4">
                                <router-link class="nav-link btn btn-light btn-text-gray-600 btn-icon-gray-600 "  v-if="$can(item.permission)"
                                            :class="[
                            {'active btn-primary': $route.name == item.routeName},
                            {'active btn-primary': item.childRouteName && item.childRouteName.length && item?.childRouteName.includes($route.name)},
                        ]"
                                            :to="{ name: item.routeName, query: { tab: $route.query.tab || 'tab-nps' } }">
                                <div class="d-flex align-items-center justify-content-start ">
                                    <i :class="item.icon" class="m-1" ></i>
                                    <span >{{ $t(item.title) }}</span>
                                </div>
                                </router-link>
                            </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-9 col-xl-9 col-12">
                    <router-view ></router-view>
                </div>
            </div>
        </template>
    </Card> 
</template>

<script>
    import abilities from "@/composables/abilities";
    import Card from "@/components/Card.vue";
    import Button from "@/components/Button.vue";

    export default {
        name: "BaseSettingLayout",
        components: {Card, Button},
        data() {
            return {
                menuItems: [
                    {
                        routeName: 'events-nps-details',
                        title: 'nps.questions',
                        icon: 'bi bi-circle-square',
                        permission: [],
                        childRouteName: ['events-nps-preview','events-nps-details']
                    },
                    {
                        routeName: 'events-nps-responses',
                        title: 'nps.responses',
                        icon: 'bi bi-circle-square',
                        permission: [],
                        childRouteName: ['events-nps-responses-details']

                    },
                    {
                        routeName: 'events-nps-statistics',
                        title: 'nps.statistics',
                        icon: 'bi bi-circle-square',
                        permission: [abilities.NPS_STATISTIC]
                    },
                ],
            }
        },
        methods: {
            backList() {
                this.$router.push({ name: 'events-nps-index', params: { id: this.$route.params.id }, query: { tab: this.$route.query.tab || 'tab-nps' } });
            }
        }
    }
</script>

<style scoped>
.btn-primary i{
    color: #FFF !important;
}
</style>
